module.exports = __webpack_public_path__ + "img/3dsjjj_img.78cf9516.png";